// ブレンドモード名の相互変換 (ag-psd は空白区切り、本アプリはハイフン区切り)
import type { BlendMode as PsdBlendMode } from 'ag-psd'
import type { GroupBlendMode } from '@/types/document'

const TO_PSD: Record<GroupBlendMode, PsdBlendMode> = {
  'pass-through': 'pass through',
  normal: 'normal',
  dissolve: 'dissolve',
  darken: 'darken',
  multiply: 'multiply',
  'color-burn': 'color burn',
  'linear-burn': 'linear burn',
  'darker-color': 'darker color',
  lighten: 'lighten',
  screen: 'screen',
  'color-dodge': 'color dodge',
  'linear-dodge': 'linear dodge',
  'lighter-color': 'lighter color',
  overlay: 'overlay',
  'soft-light': 'soft light',
  'hard-light': 'hard light',
  'vivid-light': 'vivid light',
  'linear-light': 'linear light',
  'pin-light': 'pin light',
  'hard-mix': 'hard mix',
  difference: 'difference',
  exclusion: 'exclusion',
  subtract: 'subtract',
  divide: 'divide',
  hue: 'hue',
  saturation: 'saturation',
  color: 'color',
  luminosity: 'luminosity'
}

const FROM_PSD = new Map<string, GroupBlendMode>(Object.entries(TO_PSD).map(([k, v]) => [v, k as GroupBlendMode]))

export function blendModeToPsd(mode: GroupBlendMode): PsdBlendMode {
  return TO_PSD[mode]
}

export function blendModeFromPsd(mode: string | undefined, fallback: GroupBlendMode = 'normal'): GroupBlendMode {
  if (!mode) return fallback
  return FROM_PSD.get(mode) ?? fallback
}

